import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "cssModule", "tag", "addonType", "children"];
import React from 'react';
import classNames from 'classnames';
import { mapToCssModules, tagPropType } from './utils';
import InputGroupText from './InputGroupText';
var defaultProps = {
  tag: 'div'
};
var InputGroupAddon = function InputGroupAddon(props) {
  var className = props.className,
    cssModule = props.cssModule,
    Tag = props.tag,
    addonType = props.addonType,
    children = props.children,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = mapToCssModules(classNames(className, 'input-group-' + addonType), cssModule); // Convenience to assist with transition

  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
      className: classes
    }), /*#__PURE__*/React.createElement(InputGroupText, {
      children: children
    }));
  }
  return /*#__PURE__*/React.createElement(Tag, _extends({}, attributes, {
    className: classes,
    children: children
  }));
};
InputGroupAddon.defaultProps = defaultProps;
export default InputGroupAddon;